<div class="group-container">
  <div class="group-title-container">
    <div class="header-title">{{title}}</div>
  </div>
</div>